/**
 * Decode HTML entities in a string
 *
 * @param {string} str String with HTML entities.
 * @return {string} Decoded string.
 */
export const decodeHtmlEntities = str => {
	if ( ! str || typeof str !== 'string' ) {
		return str;
	}

	// Create a temporary textarea element to decode HTML entities.
	const textarea = document.createElement( 'textarea' );
	textarea.innerHTML = str;
	return textarea.value;
};
